var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Toggle',{attrs:{"value":_vm.value,"disable":_vm.disabled,"bg-color":_vm.bgColor,"label":_vm.label,"is-legend":_vm.isLegend},on:{"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }